import axios from 'axios';

export const createAuthenticatedRequest = async (baseURL: string, token?: string | null) => {
  return axios.create({
    baseURL: baseURL,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
};
